@if (translations) {
  <div class="segmented" role="tablist">
    @for (market of markets; track market) {
      <button type="button" role="tab" class="segment"
        [class.selected]="selectedMarket?.marketname === market.marketname"
        [attr.aria-selected]="selectedMarket?.marketname === market.marketname"
        (click)="selectMarket(market)">
        {{ getMarketName(market) }}
      </button>
    }
  </div>
}
